<template>
<div class="container bg-white borda" style="padding: 0px; max-width: 1185px;">
  <form class="p-3">
    <!-- 1ª Etapa -->
    <div :class="{'active3':show}">
      <button @click.prevent="voltar()" class="btn btn-primary item3" style="font-size: 14px" tag="button">
            <i class="fas fa-backward mr-2"></i>Voltar
          </button>
    </div>
    <div :class="{'active2':show}">
      <p style="font-size: 28px;" class="margem-bot item2 borda-top">Contribuinte</p>
    </div>
    <div :class="{'active':show}">
    <div class="item">
      <h6 class="subtitulo">ADQUIRENTE</h6>
      
      
      <div class="custom-control custom-radio">
        <input
          type="radio"
          id="contribuinte"
          @click="toggleShow(),filtro.adquirente = 1, zeraDados(), mensagemNaoContribuinte = false"
          name="adquirente"
          class="custom-control-input"
          :disabled="idCliente == 9475"
        />
        <label class="custom-control-label" for="contribuinte">Contribuinte</label>
      </div>
      <div class="custom-control custom-radio">
        <input
          type="radio"
          id="naoContribuinte"
          @click="mensagemNaoContribuinte = true, filtro.destinatario = null, filtro.finalidade = null, filtro.origem = null, naoContribuinte()"
          name="adquirente"
          class="custom-control-input"
          :disabled="idCliente == 9475"
        />
        <label class="custom-control-label" for="naoContribuinte">Não Contribuinte</label>
      </div>
    </div>
      <span class="erro" v-if="filtro.validacaoAdquirente">* Preenchimento Obrigatório</span>
    </div>
    
    <!-- 1ª Etapa -->
    <div  :class="{'active4':show}">
      <div class="item4 container bg-white" style="padding: 0px; max-width: 1185px;">
    <b-row class="mt-2" v-if="filtro.adquirente == 1">
      <b-col md="6">
        <label for="ufdestino" class="margem-top subtitulo">UF DESTINO:</label>
        <b-form-select
          class="select"
          name="ufdestino"
          ref="ufdestino"
          id="ufdestino"
          v-model="filtro.ufDestino"
          :options="options"
          :value="options.Sigla"
          @select="resetaFormulario()"
          @change="verificaIDEstado()"
        ></b-form-select>
        <span class="erro" v-if="filtro.validacaoUfDestino">* Campo Obrigatório, escolha um UF</span>
        <span
          class="erro pt-3"
          v-if="mensagemEstadoInvalido == 1"
        >Não existe previsão legal para exigência da antecipação tributária</span>
        <span
          class="erro pt-3"
          v-if="mensagemEstadoInvalido == 2"
        >Cálculo em elaboração pela equipe LEFISC</span>
      </b-col>
    </b-row>
     <!-- 1ª Acre - Regra - Contribuinte -->
    <div v-if="aplicarRegraAcre">
      <h6 class="subtitulo mt-3">ANEXO</h6>
      <div class="custom-control custom-radio">
        <input
          type="radio"
          id="anexo00"
          @click="anexo = 2;"
          name="anexo"
          class="custom-control-input anexos"
        />
        <label class="custom-control-label" for="anexo00">Anexo II </label>
        
      </div>      
      <span class="erro" v-if="anexo== -1">* Preenchimento Obrigatório</span>  
      <div class="custom-control custom-radio">
        <input
          type="radio"
          id="anexo2"
          @click="anexo = 3;"
          name="anexo"
          class="custom-control-input anexos"
        />
        <label class="custom-control-label" for="anexo2">Anexo III </label>        
      </div>     
        <b-col md="6" v-if="anexo == 3">      
      <b-form-select  v-model="selected1" :options="acreOpcoes"   value-field="id" text-field="nome" >
      
        </b-form-select> 
        </b-col>
      <span class="erro" v-if="anexo== -1">* Preenchimento Obrigatório</span>
       <div class="custom-control custom-radio">
        <input
          type="radio"
          id="anexo4"
          @click="anexo = 4;"
          name="anexo"
          class="custom-control-input anexos"
        />
        <label class="custom-control-label" for="anexo4">Anexo IV </label>   
         <span class="erro" v-if="anexo== -1">* Preenchimento Obrigatório</span>     
      </div>  
       <div class="custom-control custom-radio">
        <input
          type="radio"
          id="anexo5"
          @click="anexo = 5;"
          name="anexo"
          class="custom-control-input anexos"
        />
        <label class="custom-control-label" for="anexo5">Anexo V </label>   
         <span class="erro" v-if="anexo== -1">* Preenchimento Obrigatório</span>     
      </div>                 
    </div>    
    <!-- 2ª Etapa Contribuinte -->
    <div v-if="filtro.adquirente == 1 && estadoValido">
      <h6 class="subtitulo mt-3">DESTINATARIO</h6>
      <div class="custom-control custom-radio">
        <input
          type="radio"
          id="simplesNacional"
          @click="filtro.destinatario = 1, zeraDados()"
          name="destinatario"
          class="custom-control-input"
        />
        <label class="custom-control-label" for="simplesNacional">Simples Nacional</label>
      </div>
      <div class="custom-control custom-radio">
        <input
          type="radio"
          id="modalidadeGeral"
          @click="filtro.destinatario = 2, zeraDados()"
          name="destinatario"
          class="custom-control-input"
        />
        <label class="custom-control-label" for="modalidadeGeral">Modalidade Geral</label>
      
      </div>
      <span class="erro" v-if="filtro.validacaoDestinatario">* Preenchimento Obrigatório</span>
    </div>
    <!-- 2ª Etapa Contribuinte FIM -->

    <!-- 3ª Etapa Contribuinte -->
    <div v-if="filtro.adquirente == 1 && estadoValido">
      <h6 class="subtitulo mt-3">FINALIDADE DA AQUISIÇÃO</h6>
     
      <div class="custom-control custom-radio">
        <input
          type="radio"
          id="aquisicaoUECOAI"
          @click="filtro.finalidade = 1, zeraDados()"
          name="finalidadeAquisicao"
          class="custom-control-input"
        />
        <label
          class="custom-control-label"
          for="aquisicaoUECOAI"
        >Aquisição para uso e consumo ou ativo imobilizado</label>
      </div>
      <div class="custom-control custom-radio">
        <input
          type="radio"
          id="aquisicaoComercializacao"
          @click="filtro.finalidade = 2, zeraDados()"
          name="finalidadeAquisicao"
          class="custom-control-input"
        />
        <label
          class="custom-control-label"
          for="aquisicaoComercializacao"
        >Aquisição para comercialização</label>
      </div>
      
      <div class="custom-control custom-radio">
        <input
          type="radio"
          id="aquisicaoIndustrializacao"
          @click="filtro.finalidade = 3, zeraDados()"
          name="finalidadeAquisicao"
          class="custom-control-input"
        />
        <label
          class="custom-control-label"
          for="aquisicaoIndustrializacao"
        >Aquisição para industrialização</label>
      </div>
      <span class="erro" v-if="filtro.validacaoFinalidade">* Preenchimento Obrigatório</span>
    </div>
    <!-- 3ª Etapa Contribuinte FIM -->

    <!-- 4ª Etapa Contribuinte -->
    <div v-if="filtro.adquirente == 1 && estadoValido">
      <h6 class="subtitulo mt-3">ORIGEM DA MERCADORIA</h6>
      <div class="custom-control custom-radio">
        <input
          type="radio"
          id="nacional"
          @click="filtro.origem = 1, zeraDados()"
          name="origemMercadoria"
          class="custom-control-input"
        />
        <label class="custom-control-label" for="nacional">Nacional</label>
      </div>
      <div class="custom-control custom-radio">
        <input
          type="radio"
          id="importadaouCIS40"
          @click="filtro.origem = 2, zeraDados()"
          name="origemMercadoria"
          class="custom-control-input"
        />
        <label
          class="custom-control-label"
          for="importadaouCIS40"
        >Importada ou com conteúdo de importação superior a 40%</label>
      </div>
      <span class="erro" v-if="filtro.validacaoOrigem">* Preenchimento Obrigatório</span>
      <div class="mt-3">
        <b-button class="btndef" variant="success" @click="validaFiltros()">
          Avançar
          <div class="spinner-border text-white loading" v-if="loading" role="status">
            <span class="sr-only">Aguarde...</span>
          </div>
        </b-button>
      </div>
    </div>
      
    <!-- 4ª Etapa Contribuinte FIM -->

    <!-- Modal Validação -->
    <b-modal ref="validacao-modal" id="validacao-modal" centered ok-only class="text-center">
      <div>
        <p class="tituloModal2">A UF destino selecionada não pode concluir esta operação.</p>
        <p class="tituloModal2">Base Legal: {{ mensagemErro }}</p>
      </div>
    </b-modal>
    </div>
    </div>
    <!-- Modal Validação FIM -->
  </form>
  
</div>

</template>

<script>
import Filtro from "../models/Filtro.js";
import estados from "../assets/arquivos/estados.json";
import services from "../services/serviceFiltros.js";
import objetoEnviar from "../models/objetoEnviarFiltros.js";
import campoformulario from "./campoFormulario.vue";
 
export default {
  components: {
    campoformulario
  },
  data() {
    return {
      idCliente:0,
      selected1:0,
      acreOpcoes:[],
      anexo:0,
      aplicarRegraAcre:false,
      show: false,
      filtro: {},    
      options: estados,
      formulario: false,
      mensagemErro: "",
      mensagemNaoContribuinte: false,
      loading: false,
      estado: null,
      estadoValido: true,
      mensagemEstadoInvalido: 0,
      objetoEnviar: {
        adquirente: "",
        destinatario: "",
        finalidade: "",
        origem: "",
        ufDestino: "",
      },
    };
  },

  async created() {
    this.filtro = new Filtro();
    this.acreOpcoes =  await services.getProdutosAcre()
   this.acreOpcoes.push({"nome": 'Selecione um produto','id':0})
   let obj = localStorage.getItem('objCli')   
   obj = JSON.parse(obj)
   this.idCliente = obj.idCliente
  },
  methods: {
    toggleShow(){
      this.show = !this.show
    },
    voltar(){
      this.show = !this.show
      this.filtro.adquirente = 0;
      this.filtro.adquirente.value = 0;
    },
    verificaIDEstado() {      
      this.options.forEach(estado => {
        if (estado.value == this.filtro.ufDestino) {         
          this.estado = estado.ID;      
          this.estadoValido = true;
          this.mensagemEstadoInvalido = 0;          
          return;
        }
      });
      if(this.estado ==1 ){
        this.aplicarRegraAcre = true
      }else{
        this.aplicarRegraAcre = false
      }
    },

    zeraDados() {
      this.formulario = false;
    },

    naoContribuinte() {
      this.$router.push({
        name: "calculonc",
        params: { ID: this.estado, importado: this.objetoEnviar.origem }
      });
    },

    async validaFiltros() {
      let resultado = this.filtro.validaDados();
      console.log(this.estado == '1')
      console.log(this.filtro.finalidade)
      if(this.estado == '1' && this.anexo <=0 && this.filtro.finalidade !=1){  
          console.log('ok 1')
        this.anexo = -1
      }
      if(this.estado == '1' && this.anexo == 3 &&  this.selected1 == 0){
        console.log('ok 2')
        this.anexo = -1        
        document.querySelectorAll('.anexos').forEach(e=>e.checked = false)
      }else if (resultado == 0) {
        this.objetoEnviar = new objetoEnviar();
        this.objetoEnviar.adquirente = this.filtro.adquirente;
        this.objetoEnviar.destinatario = this.filtro.destinatario;
        this.objetoEnviar.finalidade = this.filtro.finalidade;
        this.objetoEnviar.origem = this.filtro.origem;
        this.objetoEnviar.ufDestino = this.filtro.ufDestino;
        this.loading = true;

        await services.postFiltros(this.objetoEnviar).then(
          res => {
              this.loading = false;
              //if(!this.mensagemAquisicaoEstadoNaoSelecionado && !this.mensagemDestinatarioNaoSelecionado) {             
                if(res.data == "OK") {
                  this.formulario = true;                
                    this.$router.push({
                    name: "calculo",
                    params: { ID: this.estado, importado: this.objetoEnviar.origem, finalidade:this.objetoEnviar.finalidade, destinatario: this.filtro.destinatario,"anexo":this.anexo,"produtoAcre":this.selected1}
                  });
              //}
            
            } else {
              this.mensagemErro = res.data;
              this.formulario = false;
              this.$refs["validacao-modal"].show();
            }
          },
          erro => {
            this.loading = false;
            console.log(erro);
          }
        );
      }
      //requisicao de validacao
    },
   
      
    
  },
  
  
};
</script>

<style scoped>

.btndef {
  font-size: 14px;
}

.tituloModal {
  font-size: 18px;
  font-weight: bold;
}

.subtitulo {
  font-weight: bold;
  font-size: 14px;
}

.select:hover {
  cursor:pointer;
}

.borda {
  border: 1px solid rgb(236, 235, 235);
}

.erro {
  color: red;
  font-style: oblique;
  display: block;
}

.loading {
  height: 16px;
  width: 16px;
  font-size: 10px;
}

.referencia {
  padding-bottom: 5px;
  border-bottom: 1px solid 0.8px solid rgb(0, 0, 0);
  margin-bottom: 12px;
}

.border-top{
  border-top: 0.8px solid rgb(240, 240, 240);
  
}

.tela-enter-active, .tela-leave-active {
  transition: 2s all;
}
.tela-enter, .tela-leave-to
/* .component-fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;

}

.item {
  opacity: 1;
  height: 75px;
  transition: opacity 1s 0.5s, height 1s;
}

.active .item {
  opacity: 0;
  height: 8px;
  transition: opacity 1s, height 1s;
}

.margem-top {
  margin-top: 20px;
}

.item2 {
  opacity: 0;
  height: 0px;
}

.active2 .item2 {
  opacity: 1;
  height: 0;
  margin-top: 71px;
  transition: opacity 1s, height 2s;

}

.item3 {
  position:absolute;
  top: 128px;
  opacity: 0;
  height: 35px;
  transition: opacity 1s , height 1s;
}

.active3 .item3 {
  opacity: 1;
  height: 35px;
  transition: opacity 1s, height 1s;
}

.item4 {
  opacity: 0;
  transition: opacity 1s , height 1s;
}

.active4 .item4 {
  opacity: 1;
  transition: opacity 1s, height 1s;
}

.borda-top {
  border-top: 1px solid;
  border-top: 0.8px solid rgb(240, 240, 240);

}



</style>


// WEBPACK FOOTER //
// src/components/filtros.vue